import { trackEvent } from '../common/analytics';
import { isValidVin, normalizeVin } from './wmiDecoder';

export const CARVERTICAL_URL_BASE =
    'https://www.carvertical.deal/31HLNSB/5NWWWN/?uid=40&source_id=AFF&sub1=worldauto';

export const withTrackingParams = (url, { placement, language } = {}) => {
    try {
        const parsed = new URL(url);
        if (placement) parsed.searchParams.set('sub2', placement);
        if (language) parsed.searchParams.set('sub4', language);
        return parsed.toString();
    } catch {
        return url;
    }
};

export const buildCarVerticalUrl = (vin, tracking) => {
    const normalized = normalizeVin(vin);
    const base = normalized
        ? `${CARVERTICAL_URL_BASE}&sub3=${encodeURIComponent(normalized)}`
        : CARVERTICAL_URL_BASE;
    return withTrackingParams(base, tracking);
};

const vinWmi = (vin) =>
    vin ? String(vin).slice(0, 3).toUpperCase() : '';

export const trackVendorClick = ({ vendor, placement, vin, language }) => {
    trackEvent('carvertical_vendor_click', {
        event_category: 'affiliate',
        vendor,
        placement,
        has_vin: Boolean(vin) && isValidVin(vin),
        vin_wmi: vinWmi(vin),
        promo_code: vendor === 'carvertical' ? 'worldauto' : '',
        language: language || '',
    });
};

export const trackVinInvalid = ({ placement, language }) => {
    trackEvent('carvertical_vin_invalid', {
        event_category: 'affiliate',
        placement,
        language: language || '',
    });
};

export const trackVinModalOpen = ({ placement, vin, language }) => {
    trackEvent('carvertical_modal_open', {
        event_category: 'affiliate',
        placement,
        vin_wmi: vinWmi(vin),
        language: language || '',
    });
};
